import script from "./ResourcesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcesPage.vue?vue&type=script&setup=true&lang=ts"

import "./ResourcesPage.vue?vue&type=style&index=0&id=f4dcfd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4dcfd46"]])

export default __exports__